import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, } from 'react';
import { cn } from '../cn';
const BASE_FIELD = 'w-full px-[11px] py-[8px] border border-slate-300 rounded-[7px] text-[13px] bg-white text-slate-900 ' +
    'placeholder:text-slate-400 outline-none transition ' +
    'focus:border-[var(--accent)] focus:shadow-[0_0_0_3px_var(--accent-soft)] ' +
    'disabled:bg-slate-50 disabled:text-slate-400 disabled:cursor-not-allowed ' +
    'aria-[invalid=true]:border-[var(--danger)] aria-[invalid=true]:focus:shadow-[0_0_0_3px_var(--danger-soft)]';
/**
 * Input — single-line text field.
 *
 * Replaces the mockup class `.input`. Consistent styling shared with
 * `Select` and `Textarea` so forms stay visually aligned.
 *
 * @example
 *   <Input placeholder="Référence produit" />
 *   <Input type="email" invalid aria-describedby="err-email" />
 */
export const Input = forwardRef(function Input({ invalid, className, type = 'text', ...rest }, ref) {
    return (_jsx("input", { ref: ref, type: type, "aria-invalid": invalid || undefined, className: cn(BASE_FIELD, className), ...rest }));
});
export const Textarea = forwardRef(function Textarea({ invalid, className, rows = 4, ...rest }, ref) {
    return (_jsx("textarea", { ref: ref, rows: rows, "aria-invalid": invalid || undefined, className: cn(BASE_FIELD, 'resize-y leading-[20px]', className), ...rest }));
});
export const Select = forwardRef(function Select({ invalid, className, children, ...rest }, ref) {
    return (_jsx("select", { ref: ref, "aria-invalid": invalid || undefined, className: cn(BASE_FIELD, 'appearance-none pr-[28px] bg-no-repeat bg-[length:14px]', className), style: {
            backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><polyline points='6 9 12 15 18 9'/></svg>\")",
            backgroundPosition: 'right 9px center',
        }, ...rest, children: children }));
});
/**
 * Field — label + control + hint/error wrapper. Layout-agnostic;
 * does not impose grid or row direction.
 */
export function Field({ label, htmlFor, hint, error, required, children, className }) {
    return (_jsxs("div", { className: cn('flex flex-col gap-[6px]', className), children: [label ? (_jsxs("label", { htmlFor: htmlFor, className: "text-[12px] font-medium text-slate-600", children: [label, required ? _jsx("span", { className: "text-[var(--danger)] ml-0.5", children: "*" }) : null] })) : null, children, error ? (_jsx("span", { className: "text-[11px] text-[var(--danger-fg)]", children: error })) : hint ? (_jsx("span", { className: "text-[11px] text-slate-500", children: hint })) : null] }));
}
//# sourceMappingURL=Input.js.map